export {
  moveDownInTable,
  moveDownIntoTable,
  moveLeftInTable,
  moveLeftIntoTable,
  moveRightInTable,
  moveRightIntoTable,
  moveUpInTable,
  moveUpIntoTable,
} from './movement'
export { addColumnAfter, addRowAt, addRowAfter, deleteCellContents, deleteTable } from './mutation'
export {
  _putSelectionAtBeginningOfTable,
  selectColumn,
  selectDownInTable,
  selectLeftInTable,
  selectRightInTable,
  selectRow,
  selectUpInTable,
  toggleSelectTable,
} from './selection'

export enum TABLE {
  NEXT_CELL = 1,
  PREVIOUS_CELL = -1,
}
